import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import srmDialog from '@/components/srm-dialog';
import util from '@/libs/util';
import { ChangePassword } from "@/api/sys.user";
export default {
  components: {
    srmDialog: srmDialog
  },
  props: {
    isShowEditPassword: false
  },
  data: function data() {
    return {
      userInfo: JSON.parse(util.cookies.get('userInfo')),
      editForm: {
        OldPassword: null,
        NewPassword: null,
        NewPasswordRe: null
      },
      editFormRules: {
        OldPassword: [{
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
        }, {
          min: 4,
          max: 33,
          message: '长度在4到33个字符',
          trigger: 'blur'
        }],
        NewPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }, {
          min: 4,
          max: 33,
          message: '长度在4到33个字符',
          trigger: 'blur'
        }],
        NewPasswordRe: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'blur'
        }, {
          min: 4,
          max: 33,
          message: '长度在4到33个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handelDialogSubmit: function handelDialogSubmit() {
      var _this = this;

      this.$refs.editForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(vali) {
          var params, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  console.log(vali);

                  if (!(vali === true)) {
                    _context.next = 14;
                    break;
                  }

                  params = {
                    Id: _this.userInfo.ID,
                    User_Name: _this.userInfo.USER_NAME,
                    OldPassword: _this.editForm.OldPassword,
                    NewPassword: _this.editForm.NewPassword,
                    NewPasswordRe: _this.editForm.NewPasswordRe
                  };
                  _context.next = 5;
                  return ChangePassword(params);

                case 5:
                  res = _context.sent;
                  console.log(res);

                  if (!(res.code === 0)) {
                    _context.next = 12;
                    break;
                  }

                  _this.$message.success('密码修改成功');

                  _this.isShowEditPassword = false;
                  _context.next = 14;
                  break;

                case 12:
                  _this.$message.warning('新密码与确认密码不一致');

                  return _context.abrupt("return");

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.$emit('handelDialogSubmit');
    },
    handelClose: function handelClose() {
      this.$emit('closeEditPssword');
    }
  }
};